<div id="contact"></div>
<h2 class="block-title">{{ "Menu-3" | translate }}</h2>

<div class="container-contact">
  <div class="contact-person">
    <div class="contact-photo">
      <img alt="Ing. Aleš Hradil" class="profile-author" src="assets/img/design-2026/me-foto-male.jpg">
    </div>

    <div class="contact-author-block">
      <div class="contact-advisor">Ing. Aleš Hradil, EFA</div>
      <div class="contact-roles">
        {{ "AdvisorKontakt1" | translate }} | {{ "AdvisorKontakt2" | translate }} | {{ "AdvisorKontakt3" | translate }} | {{ "AdvisorKontakt4" | translate }}
      </div>

      <div class="contact-links">
        <a class="contact-info contact-info-email" href="mailto:ales.hradil@logical.codes">
          <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
          </svg>
          <span>ales.hradil&#64;logical.codes</span>
        </a>

        @if (translate.currentLang === 'cs' || translate.currentLang === 'sk') {
          <a class="contact-info contact-info-phone" href="tel:+420724710630">
            <svg class="contact-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
            </svg>
            <span>+420 724 710 630</span>
          </a>
        }
      </div>
    </div>
  </div>

  <div class="contact-qr">
    <img src="assets/img/design-2026/QR-vizitka.svg" alt="QR vizitka" width="120" height="120">
  </div>
</div>
